import React, { useState} from "react";
import imgProductLakay from '../../Layout/imgs/md3.jpg'
import ShowimagesLoading from "../../pageInside/showImagesLoading";
import './Gallery.css';

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["allFilePage"]?.[key] || fallback;

const copyToClipboard = (jsonData, func ) => {
 // Supprime les guillemets autour des valeurs (facultatif)

    navigator.clipboard.writeText(jsonData).then(() => {
      func()
    }).catch((err) => {
      console.error('Erreur lors de la copie : ', err);
    });
  };

const copyIconButtonStyle = {
  position: "absolute",
  top: 8,
  left: 8,
  zIndex: 2,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: 30,
  height: 30,
  padding: 0,
  border: "1px solid rgba(255,255,255,0.35)",
  borderRadius: 6,
  background: "rgba(15,23,42,0.6)",
  color: "#fff",
  cursor: "pointer",
  backdropFilter: "blur(2px)",
  transition: "background .15s, transform .1s",
};

const CopyIconButton = ({ onClick, title }) => (
  <button
    type="button"
    onClick={onClick}
    title={title}
    aria-label={title}
    className="lang-copy-url-btn"
    style={copyIconButtonStyle}
  >
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="9" y="9" width="13" height="13" rx="2" />
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </svg>
  </button>
);

const videoWrapperStyle = {
  position: "relative",
  display: "inline-block",
  width: "100%",
};

const videoLoad = (a, func)=>{
    return   a && a.videoPath &&  <div style={videoWrapperStyle}>
                <CopyIconButton onClick={()=>copyToClipboard(a.videoPath, func)} title={__elakayText("t003", "copy url video")} />
                <video width="100%" controls autoPlay muted>
                    <source src={a.videoPath} type="video/mp4" />
                </video>
            </div>

}

const containerStyle = {
    display: "inline-block", // Permet au div de s'adapter à l'image
    position: "relative", // Si vous voulez ajouter du contenu par-dessus
  };

  const imageStyle = {
    display: "block", // Supprime les marges ou espaces automatiques autour de l'image
    maxWidth: "100%", // Pour s'assurer qu'elle s'adapte bien à l'écran (optionnel)
  };

  const overlayStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: "white",
    backgroundColor: "rgba(0, 0, 255, 0.4)",
    padding: "1px",
    borderRadius: "20px",
  };


const imageLoad = (a, func)=>{
    return  a &&  a.imagePath && <div className="bg-image shadow-1-strong" style={containerStyle}>
    <CopyIconButton onClick={()=>copyToClipboard(a.imagePath, func)} title={__elakayText("t001", "copy url img")} />
    <ShowimagesLoading
    className="embla__slide__img"
        // className="card-img-top"
        src={a.imagePath}
        onError={event => {
            event.target.src = imgProductLakay
            event.onerror = null
          }}
        alt={a.title}
        style={imageStyle}
    />
     {/* <div className="card-body text-white text-center" style={overlayStyle}>
   <h5 className="card-title">{a.title}</h5>
 </div> */}
    </div>
}

const imageLoad1 = (a, func)=>{
    return  a &&  a.imagePath &&    <div
    className="bg-image card shadow-1-strong"
    style={{
     backgroundImage: `url(${a.imagePath})`,
     backgroundSize: 'cover', // Optionnel pour ajuster l'image
     backgroundPosition: 'center', // Optionnel pour centrer l'image
     display: "block", // Supprime les marges ou espaces automatiques autour de l'image
     width: "100%",

    //  height: '300px', // Optionnel pour donner une hauteur
   }}
    >
 <div className="card-body text-white">
   <h5 className="card-title">{a.title}</h5>
   <a onClick={()=>copyToClipboard(a.imagePath, func)} className="btn btn-outline-light">{__elakayText("t001", "copy url img")}</a>
 </div>
</div>
}

const cardFilePage =(obj, func)=>{
    if(obj.VORI === "image"){

        return imageLoad(obj, func)

} else  if(obj.VORI === "video"){
    return videoLoad(obj, func)
}
}

const AllFilePage =(props)=>{
    let ObjetPage = {
        title:'',
        image:'',
        video:'',
        thumbnail:''
    }
    
    const {
        infoSource,
        classAlert,
        classText = 'col-12 col-md-9',
        classImg = 'col-12 col-md-10',
        classPara = 'col-lg-4 col-md-12 mb-4 mb-lg-0',
        paragra = ObjetPage,
        imageVideo = '',
        paragra0 = [],
        paraALLBoo = false,

    } = props
    __setElakayInfoSource(infoSource);

    const [showAlert, setShowAlert] = useState(false);

    const triggerAlert = () => {
        setShowAlert(true);
        setTimeout(() => setShowAlert(false), 2000);
      };

    const alertCopy =()=>{
       return   showAlert && (
          <div className="alert alert-success" role="alert">{__elakayText("t002", "The JSON has been successfully copied!")}</div>
          )}

  return  <div className="container my-5">
    {alertCopy()}
  <div className="row">
    {paraALLBoo?
    <div className={`column ${classImg}`}>
    {cardFilePage(paragra, triggerAlert)}
    </div>
   :
    // <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
    
    <> {paragra0?.length > 0 && paragra0?.map((ob, j) =>{
          return <div key={j} className={`${classPara}`}>
           {cardFilePage(ob, triggerAlert)}
           </div> 
        })}
        </>
   
    
    // </div>
 }
  </div>
</div>

}

export default  AllFilePage
